export const defaultColors = [
    {
        name: "Skyline",
        background: "#F9FAFB", 
        navigation: "#2563EB", 
        accent: "#CBD5E1",     
        button: "#3B82F6"      
    },
    {
        name: "Foil-covered Sneakers",
        background: "#FAFAF7",
        navigation: "#9333EA",
        accent: "#FACC15",
        button: "#38BDF8"
    },
    {
        name: "Lake View",
        background: "#F5FAFF",
        navigation: "#DC2626",
        accent: "#A7C7E7",
        button: "#F59E0B"
    },
    {
        name: "Milky Stream",
        background: "#FAFAFA",
        navigation: "#16A34A",
        accent: "#E5E1DC",
        button: "#A38D85"
    },
    {
        name: "Berry Jar",
        background: "#FFF8F9",
        navigation: "#E11D48",
        accent: "#E8A6AD",
        button: "#14B8A6"
    },
    {
        name: "Makeshift Slumber",
        background: "#F6F7F7",
        navigation: "#F97316",
        accent: "#E2DFD9",
        button: "#9CA391"
    },
    {
        name: "Wall Greens",
        background: "#FAFBF7",
        navigation: "#0891B2",
        accent: "#D0DBA6",
        button: "#7C8572"
    },
    {
        name: "Sweet Frost Lips",
        background: "#FFF7F4",
        navigation: "#BE185D",
        accent: "#EFD6BD",
        button: "#A4715E"
    },
    {
        name: "Deep Merlot",
        background: "#FFFAF8",
        navigation: "#CA8A04",
        accent: "#DFC2CA",
        button: "#7A96A8"
    },
]